export const setUserInfo = (user = {}) => ({
  type: 'SET_USER',
  user,
});